import React from "react";

import { some } from "lodash/fp";

import useIntegrations from "@app/analytics/hooks/integrations/useIntegrations";
import ConnectTeamsChannelsModal from "@app/analytics/Integrations/ConnectTeamsChannelsModal";
import { Topic } from "@app/analytics/types";

import AlertBanner from "@rui/AlertBanner";

interface LimitedDataBannerProps {
  topic: Topic;
}

const LimitedDataBanner = ({ topic }: LimitedDataBannerProps) => {
  const [show, setShow] = React.useState(true);
  const [showRequestAccess, setShowRequestAccess] = React.useState(false);

  // Teams reports can have limited data, based on the status of the integration
  // So we only run this query if this is a microsoft channel report
  const { userIntegrations } = useIntegrations({
    enabled: some(
      (provider) => provider.includes("microsoft"),
      topic?.channelProviders
    ),
  });

  const isLimitedDataReport = some({ limitedData: true }, userIntegrations);

  if (!isLimitedDataReport || !show) return null;

  return (
    <>
      <ConnectTeamsChannelsModal
        open={showRequestAccess}
        onClose={() => setShowRequestAccess(false)}
      />
      <AlertBanner
        title="Limited Topic Data"
        severity="warning"
        action={{
          label: "Request access",
          onClick: () => setShowRequestAccess(true),
        }}
        onClose={() => setShow(false)}
      >
        Currently, your topic summaries are limited to Teams chat messages.
        Request access from your Teams admin to generate more robust topic
        summaries that include channels.
      </AlertBanner>
    </>
  );
};

export default LimitedDataBanner;
